import { useTranslation } from "react-i18next";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as MutedIcon } from "./icons/mute.svg";
import Container from "./components/Container";
import Text from "./components/Text";
import getColors from "./getColors";

export default function Muted({ isDarkMode, error, activity, mode, ...rest }) {
  const { t } = useTranslation();
  const { bg, color } = getColors({ isDarkMode, activity, mode, error });

  return (
    <Container p={["6px 12px", "8px 16px"]} bg={bg} {...rest}>
      <SvgContainer fill={color} size={["16px", "20px"]} icon={MutedIcon} />
      <Text
        color={color}
        fontSize={["12px", "16px", "20px"]}
        ml={["4px", "6px", "8px"]}
        lineHeight="1"
      >
        {t("muted")}
      </Text>
    </Container>
  );
}
